import React, { useState } from "react";
import { StaffSideMenu } from "./StaffSideMenu";
import { useNavigate } from "react-router-dom";
import API_URL from "../../api/API";
import { HiOutlinePlusSm } from "react-icons/hi";

export const CreateStaff = () => {
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("staff"); // default role
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    setIsLoading(true);

    try {
      const response = await fetch(API_URL.POST_STAFF_CREATE, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          firstname,
          lastname,
          email,
          password,
          role,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || "Something went wrong");
      } else {
        setSuccess("Staff account created successfully!");
        setFirstname("");
        setLastname("");
        setEmail("");
        setPassword("");
        setRole("staff");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex md:h-screen">
      <StaffSideMenu />
      <div className="flex-1 bg-bgBase">
        <div className="bg-white space-y-3 md:space-y-6 py-3 md:py-6 px-5 md:px-10 md:sticky md:top-0">
          <div className="w-full max-w-screen-2xl flex max-md:flex-wrap justify-between items-center gap-5 max-md:pl-14">
            <h1 className="font-inter font-medium text-dark text-2xl !leading-none">
              Create Staff
            </h1>
            <button
              onClick={() => navigate(-1)}
              className="bg-dark border border-tblBorder rounded-10 py-2.5 px-5 text-white font-inter font-medium text-sm leading-tight capitalize hover:bg-black transition"
            >
              Go Back
            </button>
          </div>
        </div>

        {isLoading && (
          <div className="p-3 mb-4 bg-yellow-100 text-yellow-700 rounded">
            Creating staff account... Please wait.
          </div>
        )}

        {success && (
          <div className="p-3 mb-4 bg-green-100 text-green-700 rounded">
            {success}
          </div>
        )}

        {error && (
          <div className="p-3 mb-4 bg-red-100 text-red-700 rounded">
            {error}
          </div>
        )}

        <div className="p-5 md:p-10 overflow-auto show-scrollbar">
          <form onSubmit={handleSubmit} className="w-full max-w-screen-2xl space-y-3 md:space-y-6 p-5 md:p-10 bg-white border border-tblBorder rounded-10">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6">
              <div>
                <label
                  htmlFor="firstname"
                  className="block font-inter text-slate100 text-sm font-medium"
                >
                  First Name
                </label>
                <input
                  type="text"
                  id="firstname"
                  value={firstname}
                  onChange={(e) => setFirstname(e.target.value)}
                  className="w-full mt-2 border border-tblBorder p-3 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-tight"
                  required
                />
              </div>

              <div>
                <label
                  htmlFor="lastname"
                  className="block font-inter text-slate100 text-sm font-medium"
                >
                  Last Name
                </label>
                <input
                  type="text"
                  id="lastname"
                  value={lastname}
                  onChange={(e) => setLastname(e.target.value)}
                  className="w-full mt-2 border border-tblBorder p-3 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-tight"
                  required
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6">
              <div>
                <label
                  htmlFor="email"
                  className="block font-inter text-slate100 text-sm font-medium"
                >
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full mt-2 border border-tblBorder p-3 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-tight"
                  required
                />
              </div>

              <div>
                <label
                  htmlFor="password"
                  className="block font-inter text-slate100 text-sm font-medium"
                >
                  Password
                </label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full mt-2 border border-tblBorder p-3 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-tight"
                  required
                />
              </div>
            </div>

            <div>
              <label
                htmlFor="role"
                className="block font-inter text-slate100 text-sm font-medium"
              >
                Role
              </label>
              <select
                id="role"
                value={role}
                onChange={(e) => setRole(e.target.value)}
                className="w-full mt-2 border border-tblBorder p-3 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-tight"
              >
                <option value="staff">Staff</option>
                <option value="master_admin">Master Admin</option>
              </select>
            </div>

            <button
              type="submit"
              className="px-6 py-2.5 flex items-center gap-2 bg-dark text-white rounded-lg hover:bg-black font-inter font-normal text-sm leading-tight ml-auto"
              disabled={isLoading}
            >
              <HiOutlinePlusSm color="#fff" size={16} className="-mb-px" /> Create Staff Account
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
